"use strict";

import angular from "angular";

import { CNPJCPFMask } from "../../utils/format/format";

const name = "cnpjCpf";
const factory = function cnpjCpfFilter() {
    return function (cnpjCpf) {
        return CNPJCPFMask(cnpjCpf);
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
